// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"498":"2b45749c","616":"e07faeec","828":"2580c6a0"}[chunkId] + ".chunk.js");